import { render, staticRenderFns } from "./ApiKeyChip.vue?vue&type=template&id=fe0b243a&"
import script from "./ApiKeyChip.vue?vue&type=script&lang=ts&"
export * from "./ApiKeyChip.vue?vue&type=script&lang=ts&"
import style0 from "./ApiKeyChip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
